/**
 * Hero Round Tabs - Interactive tab navigation
 * Handles tab switching, keyboard navigation, and accessibility
 */

(function() {
  'use strict';

  class HeroRoundTabs {
    constructor(container) {
      this.container = container;
      this.tabs = Array.from(container.querySelectorAll('.hero-round-tabs__tab'));
      this.panels = Array.from(container.querySelectorAll('.hero-round-tabs__panel'));
      this.activeIndex = 0;

      if (this.tabs.length === 0 || this.panels.length === 0) {
        return;
      }

      // Find initially active tab
      this.tabs.forEach((tab, index) => {
        if (tab.classList.contains('hero-round-tabs__tab--active')) {
          this.activeIndex = index;
        }
      });

      this.init();
    }

    init() {
      // Add click handlers to tabs
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.activateTab(index);
        });
      });

      // Add keyboard navigation
      this.container.addEventListener('keydown', (e) => this.handleKeydown(e));
    }

    activateTab(index) {
      if (index === this.activeIndex) return;
      if (index < 0 || index >= this.tabs.length) return;

      // Deactivate current tab
      this.tabs[this.activeIndex].classList.remove('hero-round-tabs__tab--active');
      this.tabs[this.activeIndex].setAttribute('aria-selected', 'false');
      this.panels[this.activeIndex].classList.remove('hero-round-tabs__panel--active');
      this.panels[this.activeIndex].setAttribute('hidden', '');

      // Activate new tab
      this.tabs[index].classList.add('hero-round-tabs__tab--active');
      this.tabs[index].setAttribute('aria-selected', 'true');
      this.panels[index].classList.add('hero-round-tabs__panel--active');
      this.panels[index].removeAttribute('hidden');

      this.activeIndex = index;
    }

    handleKeydown(event) {
      // Only handle keyboard events when focus is on a tab
      if (!event.target.classList.contains('hero-round-tabs__tab')) return;

      const { key } = event;
      let newIndex = this.activeIndex;

      switch (key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          event.preventDefault();
          newIndex = this.activeIndex === 0
            ? this.tabs.length - 1
            : this.activeIndex - 1;
          break;

        case 'ArrowRight':
        case 'ArrowDown':
          event.preventDefault();
          newIndex = this.activeIndex === this.tabs.length - 1
            ? 0
            : this.activeIndex + 1;
          break;

        case 'Home':
          event.preventDefault();
          newIndex = 0;
          break;

        case 'End':
          event.preventDefault();
          newIndex = this.tabs.length - 1;
          break;

        default:
          return;
      }

      this.activateTab(newIndex);
      this.tabs[newIndex].focus();
    }
  }

  // Initialize all hero round tabs on the page
  function initHeroRoundTabs() {
    const containers = document.querySelectorAll('.hero-round-tabs');
    containers.forEach(container => new HeroRoundTabs(container));
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroRoundTabs);
  } else {
    initHeroRoundTabs();
  }

  // Re-initialize when Shopify theme editor updates sections
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const container = event.target.querySelector('.hero-round-tabs');
      if (container) {
        new HeroRoundTabs(container);
      }
    });
  }
})();
